import * as React from 'react';

export const Shodi: React.FunctionComponent = () => {
  return (
    <svg id="Outline" enableBackground="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512">
      <path d="m488 480h-8v-312c0-4.418-3.582-8-8-8h-48v-128h24c4.418 0 8-3.582 8-8s-3.582-8-8-8h-32c-.062 0-3.12-.078-5.381 2.083l-349.712 317.917h-12.907c-4.418 0-8 3.582-8 8s3.582 8 8 8h16c1.99 0 3.909-.742 5.382-2.08l34.618-31.471v81.551h-16c-4.418 0-8 3.582-8 8v72h-40c-4.418 0-8 3.582-8 8s3.582 8 8 8h448c4.418 0 8-3.582 8-8s-3.582-8-8-8zm-224-307.006 144-130.909v117.915h-40c-4.418 0-8 3.582-8 8v72h-72c-4.418 0-8 3.582-8 8v72h-16zm-16 14.546v132.46h-56c-4.418 0-8 3.582-8 8v72h-64v-96h-.106zm216 292.46h-368v-64h96c4.418 0 8-3.582 8-8v-72h88c4.418 0 8-3.582 8-8v-72h72c4.418 0 8-3.582 8-8v-72h88z" />
    </svg>
  );
};
